import { Box } from "@mui/material";
import SecurityPassIcon from "@/assets/icons/compare-devices/security-pass.svg?react";
import RemoveIcon from "@mui/icons-material/Remove";

export const CheckedIcon = ({ checked }: { checked: boolean }) => {
  return (
    <>
      {checked ? (
        <Box
          sx={{
            width: { xs: 18, md: 24 },
            height: { xs: 18, md: 24 },
            boxSizing: "border-box",
            ml: "auto",
            mr: { lg: "auto" },
            "& svg": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <SecurityPassIcon />
        </Box>
      ) : (
        <Box
          sx={{
            width: { xs: 10, md: 12 },
            height: { xs: 10, md: 12 },
            boxSizing: "border-box",
            ml: "auto",
            mr: { lg: "auto" },
            "& svg": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <RemoveIcon color="inherit" />
        </Box>
      )}
    </>
  );
};
